/**
 * [懒猪学院接口]
 * @author: Fu Xiaochun
 * @date: 2021-08-27 
 */


import http from '@/assets/api/http';

// 获取课程列表
export async function getLessions(params){
    return http('/?cmd=com.xqxc.api.pig.mis.biz.platform.LanzhuCollegeMisService.listAllCourse',params,'POST');
}

// 获取课程类型列表
export async function getClassList(params){
    return http('/?cmd=com.xqxc.api.pig.mis.biz.platform.LanzhuCollegeMisService.listAllCourseType',params,'POST');
}

// 新增课程类型
export async function addClass(params){
    return http('/?cmd=com.xqxc.api.pig.mis.biz.platform.LanzhuCollegeMisService.addCourseType',params,'POST');
}
// 更新课程类型
export async function updateClass(params){
    return http('/?cmd=com.xqxc.api.pig.mis.biz.platform.LanzhuCollegeMisService.updateCourseType',params,'POST');
}

// 删除课程类型
export async function deleteClass(params){
    return http('/?cmd=com.xqxc.api.pig.mis.biz.platform.LanzhuCollegeMisService.deleteCourseType',params,'POST');
}

// 排序课程
export async function sortClassLession(params){
    return http('/?cmd=com.xqxc.api.pig.mis.biz.platform.LanzhuCollegeMisService.updateCourseSortNum',params,'POST');
}

// 新增课程
export async function addLession(params){
    return http('/?cmd=com.xqxc.api.pig.mis.biz.platform.LanzhuCollegeMisService.addCourse',params,'POST');
}

// 查询课程详情
export async function getLession(params){
    return http('/?cmd=com.xqxc.api.pig.mis.biz.platform.LanzhuCollegeMisService.getCourse',params,'POST');
}

// 更新课程
export async function updateLession(params){
    return http('/?cmd=com.xqxc.api.pig.mis.biz.platform.LanzhuCollegeMisService.updateCourse',params,'POST');
}

// 删除课程
export async function deleteLession(params){
    return http('/?cmd=com.xqxc.api.pig.mis.biz.platform.LanzhuCollegeMisService.deleteCourse',params,'POST');
}

// 移动课程
export async function moveLession(params){
    return http('/?cmd=com.xqxc.api.pig.mis.biz.platform.LanzhuCollegeMisService.moveCourse',params,'POST');
}